// Identificativo di questa scheda del browser. Viaggia nell'header
// X-Client-Id di ogni richiesta e torna negli eventi realtime: così la scheda
// che ha fatto una modifica riconosce l'eco del proprio evento e non la
// applica due volte (le altre schede dello stesso utente invece sì).
export const CLIENT_ID = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
